import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';

export interface RatingShopsType {
  rating: number;
  ratingCount: number;
  reviews: number;
  shopId: number;
}

export type ReturnTypeFetchRatingShops = RatingShopsType[];

export const fetchRatingShops = async ({ listId }: { listId: number[] }): Promise<ReturnTypeFetchRatingShops> => {
  return MyAxios.post('/api/shops/get-reviews-and-rating', { shopsId: listId }).then(handleResponse).catch(handleError);
};
